/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-no-bind */
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';

//import "./topbar.less"
import Logo from './toyota_logo.svg';
import { parseSearch, serializeSearch } from '../../core/utils';

export default class Topbar extends React.Component {
	static propTypes = {
		layoutActions: PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			url: props.specSelectors.url(),
			selectedIndex: 0,
			selectedReleaseIndex: 0,
			s3ReleaseVersions: this.loadData('/release-notes/versions.json')
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.specSelectors.url() !== this.props.specSelectors.url()) {
			this.setState({ url: nextProps.specSelectors.url() });
		}
	}

	onUrlChange = (e) => {
		let { target: { value } } = e;
		this.setState({ url: value });
	};

	loadSpec = (url) => {
		this.props.specActions.updateUrl(url);
		this.props.specActions.download(url);
	};

	onUrlSelect = (e) => {
		let url = e.target.value || e.target.href;
		this.loadSpec(url);
		this.setSelectedUrl(url);
		e.preventDefault();
	};

	downloadUrl = (e) => {
		this.loadSpec(this.state.url);
		e.preventDefault();
	};

	setSearch = (spec) => {
		let search = parseSearch();
		search['urls.primaryName'] = spec.name;
		const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
		if (window && window.history && window.history.pushState) {
			window.history.replaceState(null, '', `${newUrl}?${serializeSearch(search)}`);
		}
	};

	loadData = (url) => {
		fetch(url).then(function (response) {
			if (response.ok) {
				return response.json();
			}
			throw new Error('Error message.');
		}).then(function (data) {
			data = data.sort().reverse();
			this.setState({ s3ReleaseVersions: data });
		}.bind(this)).catch(function (err) {
			console.log("failed to load ", url, err.message);
			this.setState({ s3ReleaseVersions: [] });
		});
	}

	setSelectedUrl = (selectedUrl) => {
		const configs = this.props.getConfigs();
		const urls = configs.urls || [];

		if (urls && urls.length) {
			if (selectedUrl) {
				urls.forEach((spec, i) => {
					if (spec.url === selectedUrl) {
						this.setState({ selectedIndex: i });
						this.setSearch(spec);
					}
				});
			}
		}
	};

	componentDidMount() {
		const configs = this.props.getConfigs();
		const urls = configs.urls || [];

		if (urls && urls.length) {
			var targetIndex = this.state.selectedIndex;
			let primaryName = configs['urls.primaryName'];
			if (primaryName) {
				urls.forEach((spec, i) => {
					if (spec.name === primaryName) {
						this.setState({ selectedIndex: i });
						targetIndex = i;
					}
				});
			}

			this.loadSpec(urls[targetIndex].url);
		}

		if (window.location.href.includes("#unsubscribe/") || window.location.href.includes("#/unsubscribe/")) {
			document.querySelector(".triggerUnsubscribe").click();
		}

	}

	onFilterChange = (e) => {
		let { target: { value } } = e;
		this.props.layoutActions.updateFilter(value);
	};

	selectScriptOption = (e) => {
		return this.setState({ selectedScriptType: e.target.value });
	};

	onChangeRelease = (event) => {
		const value = event.target.value;
		if (value !== "0") {
			const newWindow = window.open(value, '_blank', 'noopener,noreferrer')
			if (newWindow) newWindow.opener = null
		}
	};

	handleLogOut = () => {
		const storedData = sessionStorage.getItem('CognitoSession');
		const parsedData = JSON.parse(storedData);
		parsedData.email_varified = false;
		sessionStorage.setItem('CognitoSession', JSON.stringify(parsedData));
		window.location.reload();
	}

	render() {
		let {
			getComponent,
			specSelectors,
			getConfigs,
			currentView = 'API',
			handleViewChange,
			extraButtons,
		} = this.props;
		const Button = getComponent('Button');
		const Link = getComponent('Link');

		let isLoading = specSelectors.loadingStatus() === 'loading';
		let isFailed = specSelectors.loadingStatus() === 'failed';

		const classNames = ['download-url-input'];
		if (isFailed) classNames.push('failed');
		if (isLoading) classNames.push('loading');

		const { urls } = getConfigs();
		let control = [];
		let formOnSubmit = null;

		let releaseControl = [];
		let releaseVersions = [];
		if (this.state.s3ReleaseVersions?.length > 0) {

			this.state.s3ReleaseVersions.forEach((link, i) => {
				releaseVersions.push(
					<option key={i} value={link.url}>
						{link.version}
					</option>
				);
			});
			releaseControl.push(
				<label className="select-label" htmlFor="select">
					<span>Release Notes:</span>
					<select
						id="selectRelease"
						onChange={this.onChangeRelease}
						defaultValue={0}
					>
						<option value="0"> -Select- </option>
						{releaseVersions}
					</select>
				</label>
			);
		}


		if (urls) {
			let rows = [];
			urls.forEach((link, i) => {
				rows.push(
					<option key={i} value={link.url}>
						{link.name}
					</option>
				);
			});

			control.push(
				<label className="select-label" htmlFor="select">
					<span>Select a definition</span>
					<select
						id="select"
						disabled={isLoading}
						onChange={this.onUrlSelect}
						value={urls[this.state.selectedIndex].url}
					>
						{rows}
					</select>
				</label>
			);
		} else {
			formOnSubmit = this.downloadUrl;
			control.push(
				<input
					className={classNames.join(' ')}
					type="text"
					onChange={this.onUrlChange}
					value={this.state.url}
					disabled={isLoading}
				/>
			);
			control.push(
				<Button className="download-url-button" onClick={this.downloadUrl}>
					Explore
				</Button>
			);
		}

		return (
			<div className="topbar bootstrap-scope">
				<div className="wrapper">
					<div className="topbar-wrapper">
						<Link className="col-2">
							<img height="20" src={Logo} alt="Swagger UI" />
						</Link>

						<nav className="nav nav-tabs">
							{extraButtons.map((btn) => {
								return (
									<div
										className={`nav-link text-center ${currentView === btn.type ? 'active' : ''}`}
										key={btn.type}
										onClick={() => handleViewChange(btn.type)}
									>
										<div className="w-100 text-center">{btn.name}</div>
									</div>
								);
							})}
						</nav>

						{releaseControl.length > 0 ? (
							<div className="download-url-wrapper">
								{releaseControl.map((el, i) => cloneElement(el, { key: i }))}
							</div>
						) : null}
						{currentView !== 'instructions' && currentView !== 'healthDashboard' && currentView !== 'incidents' ? (
							<form className="download-url-wrapper" onSubmit={formOnSubmit}>
								{control.map((el, i) => cloneElement(el, { key: i }))}
							</form>
						) : null}
						<div className='logout'><button onClick={this.handleLogOut}>Logout</button></div>
					</div>
				</div>
				<div className="w-100 text-center triggerUnsubscribe d-none" onClick={() => handleViewChange("unsubscribe")}>Unsubscribe</div>
			</div>

		);
	}
}

Topbar.propTypes = {
	specSelectors: PropTypes.object.isRequired,
	specActions: PropTypes.object.isRequired,
	getComponent: PropTypes.func.isRequired,
	getConfigs: PropTypes.func.isRequired,
	currentView: PropTypes.string,
	handleViewChange: PropTypes.func.isRequired,
	extraButtons: PropTypes.object
};
